import { createActionConfig } from './create-action-config';

export const type = '@appcues/request-review';
export const getRequestReview = () =>
  createActionConfig({
    type,
  });
